import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/api', // 使用代理路径
  timeout: 15000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求锁Map
const pendingRequestMap = new Map();

function getRequestKey(config) {
  const { url, method, params, data } = config;
  return [
    url,
    method,
    JSON.stringify(params || {}),
    typeof data === 'string' ? data : JSON.stringify(data || {})
  ].join('&');
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    const key = getRequestKey(config);
    if (pendingRequestMap.has(key)) {
      return Promise.reject(new Error('请勿重复提交请求'));
    }
    pendingRequestMap.set(key, true);
    // token逻辑
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['token'] = token;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const key = getRequestKey(response.config);
    pendingRequestMap.delete(key);
    console.log(response);
    
    // 处理文件下载
    if (response.config.responseType === 'blob') {
      const blob = new Blob([response.data])
      const contentDisposition = response.headers['content-disposition']
      let filename = 'download.xlsx'
      
      if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(contentDisposition)
        if (matches != null && matches[1]) {
          filename = decodeURIComponent(matches[1].replace(/['"]/g, ''))
        }
      }
      
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      window.URL.revokeObjectURL(link.href)
      return {
        code: 200,
        data: null,
        message: '下载成功'
      }
    }
    
    const res = response.data

    // 如果返回的状态码不是200，说明接口请求有误
    if (res.code !== 200) {
      ElMessage({
        message: res.data || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })

      // 401: 未登录或token过期
      if (res.code === 401) {
        // 清除本地token
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        
        // 跳转到登录页
        router.push('/login')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    } else {
      // 处理无内容返回的情况
      if (res.data === null || res.data === undefined || res.data === '' || res.data === void 0) {
        return {
          code: 200,
          data: [],
          message: '暂无数据'
        }
      }
      return res
    }
  },
  error => {
    if (error.config) {
      const key = getRequestKey(error.config);
      pendingRequestMap.delete(key);
    }
    console.error('响应错误:', error)
    ElMessage({
      message: error.message || '请求失败',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// 添加下载方法
export const downloadFile = (url, params = {}) => {
  return service({
    url,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export default service 